import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_star = _resolveComponent("star")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    "model-value": _ctx.selectedUserClient,
    label: "Name, email or file ref no.",
    options: _ctx.sortedUserClients,
    "option-label": _ctx.optionLabel,
    "option-value": "id",
    loading: _ctx.loading,
    "use-input": "",
    clearable: "",
    filled: "",
    dense: "",
    "input-debounce": _ctx.wait,
    "clear-icon": "fa fa-times",
    "onUpdate:modelValue": _ctx.change,
    onFilter: _ctx.filter,
    onFocus: _ctx.onFocus
  }, {
    prepend: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: "fa fa-search",
        size: "xs",
        color: "primary"
      })
    ]),
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_star, {
                size: "xs",
                "user-client": scope.opt
              }, null, 8, ["user-client"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.clientName(scope.opt.client)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_label, { caption: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt.client.email) + ", #" + _toDisplayString(scope.opt.client.fileRefNo), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    _: 1
  }, 8, ["model-value", "options", "option-label", "loading", "input-debounce", "onUpdate:modelValue", "onFilter", "onFocus"]))
}